import { convertToFloat } from '@/utilz';
import { Col, Divider, Form, Row } from 'antd';
import { cloneDeep } from 'es-toolkit/object';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { updateLossAndDamageClaimDetailsInProgress } from '../../../../../../redux/Claims/LossAndDamage/LossAndDamageClaimsActions';
import { LADCovertDatesFromMomentToAPIType } from '../../../../../../utilz/PreClaimsUtils';
import Button from '../../../../../components/Buttons/Button';
import SaveCancelButton from '../../../../../components/Common/SaveCancelButton';
import PrimaryLabel from '../../../../../components/Labels/PrimaryLabel';
import LADClaimFinancialsForm from './LADClaimFinancialsForm';

const LADClaimFinancialsTab = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [editMode, setEditMode] = useState(false);
  const { claimDetails } = useSelector((state) => state.lossAndDamage);

  const handleSubmit = (data) => {
    let payload = cloneDeep(claimDetails?.data);
    payload = { ...payload, ...data };
    payload = LADCovertDatesFromMomentToAPIType(payload);
    payload.handleDone = () => {
      setEditMode(false);
    };
    dispatch(updateLossAndDamageClaimDetailsInProgress(payload));
  };

  const handleCancel = () => {
    form.setFieldsValue(claimDetails?.data);
    setEditMode(false);
  };

  useEffect(() => {
    if (claimDetails?.data) {
      form.setFieldsValue({
        ...claimDetails.data,
        claimDeductibleAmount: convertToFloat(claimDetails.data.claimDeductibleAmount),
        interestExpense: convertToFloat(claimDetails.data.interestExpense),
        claimCreditAmount: convertToFloat(claimDetails.data.claimCreditAmount),
        claimTaxAmount: convertToFloat(claimDetails.data.claimTaxAmount),
        claimFreightCharge: convertToFloat(claimDetails.data.claimFreightCharge),
        claimAddCharge: convertToFloat(claimDetails.data.claimAddCharge),
        laborCharge: convertToFloat(claimDetails.data.laborCharge),
        inspectionCost: convertToFloat(claimDetails.data.inspectionCost),
        claimAdminCharge: convertToFloat(claimDetails.data.claimAdminCharge),
        salvageAmount: convertToFloat(claimDetails.data.salvageAmount),
        repairCostAmount: convertToFloat(claimDetails.data.repairCostAmount),
        productClaimAmount: convertToFloat(claimDetails.data.productClaimAmount),
      });
    }
  }, [claimDetails?.data]);

  return (
    <Form form={form} onFinish={handleSubmit} className="d-flex flex-direction-column h-100 overflow-hidden">
      <Row className="align-items-center pt-15 px-30" justify="space-between">
        <Col>
          <PrimaryLabel className="fw-700 f-18">Claim Financials</PrimaryLabel>
        </Col>
        <Col>
          <Row justify="space-between" gutter={16}>
            <Col>
              {!editMode ? (
                <Button onClick={() => setEditMode(true)}>Edit</Button>
              ) : (
                <SaveCancelButton editMode onCancel={handleCancel} />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        <div className="px-30">
          <LADClaimFinancialsForm
            form={form}
            editMode={editMode}
            setEditMode={setEditMode}
            items={claimDetails?.data?.claimItem || []}
            detailsData={claimDetails?.data || {}}
          />
        </div>
      </div>
    </Form>
  );
};

export default LADClaimFinancialsTab;
